import { useTranslation } from 'react-i18next';
import { twJoin } from 'tailwind-merge';

import { Coin, GemIcon } from '@/components/icons';
import ConditionalRenderer from '@/components/ui/custom/ConditionalRenderer';
import { Skeleton } from '@/components/ui/daisy/skeleton';
import { useAppShell } from '@/data/context/AppShellContext';

export default function AccountRewards() {
  const { rewards, isLoadingRewards } = useAppShell();
  const { t } = useTranslation('translation', {
    keyPrefix: 'appShell.account',
  });

  const stats = [
    {
      label: t('coins'),
      value: rewards?.coins,
      icon: Coin,
      className: 'text-warning',
    },
    {
      label: t('gems'),
      value: rewards?.gems,
      icon: GemIcon,
      className: 'border-l border-dashed border-base-content/10 text-info',
    },
  ];

  return (
    <dl className="grid grid-cols-2">
      {stats.map(({ label, value, icon: Icon, className }) => (
        <div
          key={label}
          className={twJoin('flex flex-col items-start px-4 py-2', className)}
        >
          <dt className="text-xs text-base-content/60 leading-5">{label}</dt>
          <dd className="flex h-7 items-center gap-1.5 text-lg font-bold">
            <Icon className="size-5 shrink-0" />
            <ConditionalRenderer
              condition={!isLoadingRewards}
              fallback={<Skeleton className="h-5 w-10" />}
            >
              {Math.round(value ?? 0)}
            </ConditionalRenderer>
          </dd>
        </div>
      ))}
    </dl>
  );
}
